/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createMaxLengthStringType } from 'schemas/common/string';

export const FirstName = createMaxLengthStringType(40);
export const LastName = createMaxLengthStringType(40);
